import apiClient from '@/config/api';
import type { PaginatedResponse } from '@/types/common';
import type {
  League,
  LeagueDetail,
  LeagueCreateRequest,
  LeagueUpdateRequest,
  LeagueListParams,
} from '@/types/league';

export const leaguesApi = {
  // 리그 목록 조회
  getList: async (params?: LeagueListParams): Promise<PaginatedResponse<League>> => {
    const response = await apiClient.get('/admin/leagues', { params });
    return response.data.data;
  },

  // 리그 상세 조회 (rankings 포함)
  getDetail: async (id: string): Promise<LeagueDetail> => {
    const response = await apiClient.get(`/admin/leagues/${id}`);
    return response.data.data;
  },

  // 리그 생성
  create: async (data: LeagueCreateRequest): Promise<League> => {
    const response = await apiClient.post('/admin/leagues', data);
    return response.data.data;
  },

  // 리그 수정 (DRAFT/SCHEDULED 상태만 허용)
  update: async (id: string, data: LeagueUpdateRequest): Promise<League> => {
    const response = await apiClient.patch(`/admin/leagues/${id}`, data);
    return response.data.data;
  },

  // DRAFT → SCHEDULED
  publish: async (id: string): Promise<League> => {
    const response = await apiClient.post(`/admin/leagues/${id}/publish`);
    return response.data.data;
  },

  // → ACTIVE
  start: async (id: string): Promise<League> => {
    const response = await apiClient.post(`/admin/leagues/${id}/start`);
    return response.data.data;
  },

  // → ENDED (winner 확정)
  end: async (id: string): Promise<League> => {
    const response = await apiClient.post(`/admin/leagues/${id}/end`);
    return response.data.data;
  },

  // 삭제 (DRAFT만 허용)
  remove: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/leagues/${id}`);
  },
};
